export enum Flags {
  PLANNED_MAINTENANCE = "op_PlannedMaintenance",
  SCHEDULED_MAINTENANCE = "op_ScheduledMaintenance",
  CHALLENGE_JOURNEY = "am2_1613_ChallengeJourney",
  BANK_DETAILS_JOURNEY = "am2-1903-bankdetailsjourney",
}

export type FlagValue = boolean | object | number;